<template>
  <div>
    <div class="bg-light px-3 py-3">
      <router-link
        to="/"
        class="text-muted">
        Go Back
      </router-link>
    </div>
    <div class="authentication">
      <router-view/>
    </div>
    <copyright-bar class="fixed-bottom"/>
  </div>
</template>

<script>
import CopyrightBar from '@/components/navigation/CopyrightBar.vue'

export default {
  name: 'Authentication',
  components: {
    CopyrightBar,
  },
}
</script>

<style>
.authentication {
  min-height: 500px;
  width: 100%;
}
</style>
